import styled, { css } from 'styled-components';

export const StyledDiscountCard = styled.img`
  position: absolute;
  top: 0%;
  max-width: 610px;
  width: 100%;
`;